import { ORDER_STATUS_LABELS, VENDOR_STATUS_LABELS, REVIEW_STATUS_LABELS, PAYMENT_STATUS_LABELS, PRODUCT_STATUS_LABELS } from '@/utils/formatters'

const MAP = {
  order:   ORDER_STATUS_LABELS,
  payment: PAYMENT_STATUS_LABELS,
  vendor:  VENDOR_STATUS_LABELS,
  review:  REVIEW_STATUS_LABELS,
  product: PRODUCT_STATUS_LABELS,
}

export default function StatusBadge({ status, type = 'order', lang = 'ar' }) {
  const map = MAP[type]
  const entry = map?.[status]
  if (!entry) {
    return (
      <span className="badge-draft">{status}</span>
    )
  }
  return (
    <span className={entry.class}>
      {entry[lang] || entry.en}
    </span>
  )
}
